import React, { Component } from 'react';
import HeaderBar from '../components/helpers/HeaderBar.jsx';
import HeaderLinks from '../components/helpers/HeaderLinks.jsx';
import SignInButtons from '../components/signin/SignInButtons.jsx';

export default class SignInPage extends Component {

  render () {
    return (
      <div>
        <HeaderBar rightAction={
            <HeaderLinks auth={this.props.auth} />
          } />
        <div className="sign-in-wrapper">
          <SignInButtons auth={this.props.auth} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SignInPage.jsx